import { databaseChoresTypes } from '../../constants/types';

const { ping } = databaseChoresTypes.actions;

export const mutations = {
  [ping]: (state, { response }) => {
    state.ping = response.data.value && response.data.value.length > 0 ? response.data.value[0] : null;
  }
};
